const accessTxt = (() => {

  const pageAccess = (document.getElementById("pageAccess") != null);
  if (pageAccess) {


    // img-box要素の一覧を取得
  let imgBoxes = document.querySelectorAll('.img-box');

  if (imgBoxes.length > 0) {
    imgBoxes.forEach((imgBox) => {
      let areaImg = imgBox.querySelector('.js-areaimg'); 
      let areaImg2 = imgBox.querySelector('.js-areaimg2'); 
      let accessImgTxt = imgBox.querySelectorAll('.js-img-txt');

      gsap.set(accessImgTxt, {
        opacity: 0,
        filter: "blur(3px)",
        y: 20,
      });

      ScrollTrigger.create({
        trigger: imgBox, 
        start: "0% 100%", // 画面内に入ったときの開始位置
        // markers: true,
        onEnter: () => {
          gsap.to(areaImg, {
            duration: 1.3,
            maskSize: '100%',
            ease:"expo.out",
          });
        },
      });

      ScrollTrigger.create({
        trigger: imgBox, 
        start: "0% 100%", // 画面内に入ったときの開始位置
        // markers: true,
        onEnter: () => {
          gsap.to(areaImg2, {
            duration: 1.3,
            maskSize: '100%',
            ease:"expo.out",
          });
        },
      });

      ScrollTrigger.create({
        trigger: imgBox, 
        start: "70% 80%", // 画面内に入ったときの開始位置
        // markers: true,
        onEnter: () => {
          gsap.to(accessImgTxt, {
            opacity: 1,
            filter: "blur(0px)",
            y: 0,
            duration: 0.6,
            // delay: 0.8,
            stagger: {
              each: 0.4,
            },
          });
        },
      });
    });
  }






  }

})();
export default accessTxt;